import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { isMobileQuery } from "../../utils/helpers";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const DownloadSiteWhatsapp = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isScrollAtTop, setIsScrollAtTop] = useState(true);
  const isMobile = useMediaQuery(isMobileQuery);

  const phoneNumber = "7977954690"; // your WhatsApp number
  const message =
    "Hi, I'm interested in your service. Can you share more details?";

  const handleOpenWhatsapp = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrollAtTop(window.scrollY === 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <button
      onClick={handleOpenWhatsapp}
      className={`flex items-center bg-white border-[3px] border-[#354a9e] shadow-lg 
rounded-full px-2 py-2 mb-20 mr-5 transition-all duration-300 hover:bg-gray-100 overflow-hidden
${isScrollAtTop ? "translate-y-0" : "translate-y-[-10px]"}
${isMobile ? "w-12" : isHovered ? "w-48" : "w-12"}`}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => !isMobile && setIsHovered(false)}
    >
      <WhatsAppIcon
        sx={{
          fontSize: 28,
          color: "#25D366",
          flexShrink: 0,
        }}
      />

      {/* ✅ Text only shows on desktop hover */}
      {!isMobile && (
        <span
          className={`ml-2 text-sm font-medium text-gray-700 whitespace-nowrap transition-all duration-300 
            ${isHovered
              ? "opacity-100 translate-x-0"
              : "opacity-0 -translate-x-3"
            }`}
        >
          Chat on WhatsApp
        </span>
      )}
    </button>
  );
};

export default DownloadSiteWhatsapp;
